import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import styles from './DrawerInfoRow.module.scss'

const DrawerInfoRow = ({
  label,
  value,
  inline = false,
  className = ''
}) => {
  return (
    <Box className={`${inline ? styles.detailRowInline : styles.detailRow} ${className}`}>
      <Typography className={styles.detailLabel}>
        {label}
      </Typography>
      <Typography className={styles.detailValue}>
        {value}
      </Typography>
    </Box>
  )
}

DrawerInfoRow.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.node.isRequired,
  inline: PropTypes.bool,
  className: PropTypes.string
}

export default DrawerInfoRow
